"use strict";

// Mobile Flickity Product Gallery Handler
Shopify.theme.jsFlickityProduct = {
	mobileFlickity: null,
	thumbnailFlickity: null,

	// Initialize mobile gallery with thumbnails
	init: function (settings) {
		// Check if desktop or mobile
		const isDesktop = window.innerWidth > 798;

		let self = this;

		// Get settings from liquid or use defaults
		this.settings = {
			displayThumbnails: settings.displayThumbnails || false,
			enableThumbnailSlider: settings.enableThumbnailSlider || false,
			productId: settings.productId || null,
			mediaCount: settings.mediaCount || 0,
		};

		// On desktop, skip thumbnails regardless of settings
		// On mobile, check if thumbnails are enabled
		if (
			!isDesktop &&
			this.settings.displayThumbnails &&
			this.settings.mediaCount > 1
		) {
			// Initialize thumbnails first, then main flickity (mobile only)
			this.initThumbnails();
		}

		// Always initialize main flickity (both desktop and mobile)
		this.initMainFlickity();

		// Set up event listeners
		this.setupEventListeners();
		this.setupNavigationButtons();

		// Delay showAllSlides call to ensure flickity instances are fully ready
		// This matches the working behavior that happens after variant changes
		setTimeout(() => {
			this.showAllSlides();
			// Initialize counter on load (mobile only)
			if (this.mobileFlickity && window.innerWidth <= 798) {
				this.updateImageCounter();
			}
		}, 200);
	},

	// Initialize main mobile flickity
	initMainFlickity: function () {
		let self = this;

		// Main flickity configuration
		let mainConfig = {
			cellAlign: "left",
			contain: true,
			wrapAround: true,
			prevNextButtons: false,
			pageDots: false,
		};

		this.mobileFlickity = new Flickity(".pdp-slider", mainConfig);

		// Set up slide change event
		this.mobileFlickity.on("change", function (index) {
			self.handleSlideChange(index);
			self.updateImageCounter();
			// Sync thumbnail position (mobile only)
			if (window.innerWidth <= 798 && self.thumbnailFlickity) {
				// Use select with instant option to prevent animation issues
				self.thumbnailFlickity.select(index, false, true); // index, isWrapped, isInstant
				self.updateActiveThumbnail(index);
				// Removed centerThumbnailOnActive - let Flickity handle positioning
			}
		});

		// Initialize scrollbar
		this.initScrollbarDrag();
		this.updateScrollbar();
	},

	// Initialize thumbnail Flickity carousel
	initThumbnails: function () {
		// Check if thumbnail container exists using custom class
		let thumbnailContainer = document.querySelector(
			".pdp-flickity-thumbnails"
		);
		if (!thumbnailContainer) {
			return;
		}

		let self = this;

		// Configure thumbnail Flickity carousel
		let thumbnailConfig = {
			cellAlign: "left",
			contain: true, // Changed to true to prevent overflow
			prevNextButtons: false,
			pageDots: false,
			freeScroll: false, // Changed to false for controlled scrolling
			groupCells: false, // Changed to false for individual cell control
			wrapAround: false, // Changed to false to prevent wrap-around issues
		};

		// Initialize thumbnail Flickity
		this.thumbnailFlickity = new Flickity(
			thumbnailContainer,
			thumbnailConfig
		);

		// Add click handlers to individual thumbnails
		let thumbnails = document.querySelectorAll(
			".pdp-flickity-thumbnails .product-gallery__thumbnail"
		);

		thumbnails.forEach(function (thumbnail, index) {
			thumbnail.addEventListener("click", function () {
				if (self.mobileFlickity && window.innerWidth <= 798) {
					self.mobileFlickity.select(index);
					self.updateActiveThumbnail(index);
					// Removed centerThumbnailOnActive - let Flickity handle positioning
				}
			});
		});

		// Set initial active state
		this.updateActiveThumbnail(0);
	},

	// Handle slide change events
	handleSlideChange: function (index) {
		if (!this.mobileFlickity) return;

		let activeSlide = this.mobileFlickity.selectedElement;
		if (!activeSlide) return;

		// Handle media-specific actions (video, model, etc.)
		let mediaType = activeSlide.getAttribute("data-media-type");

		// Pause videos in inactive slides
		this.pauseInactiveMedia();

		// Play active media if applicable
		if (mediaType === "video" || mediaType === "external_video") {
			this.playActiveVideo(activeSlide);
		}

		// Update thumbnail active state (mobile only)
		if (window.innerWidth <= 798) {
			let currentIndex = this.mobileFlickity.selectedIndex;
			this.updateActiveThumbnail(currentIndex);
			// Removed centerThumbnailOnActive - let Flickity handle positioning
			this.updateScrollbar();
		}
	},

	// Update active thumbnail state
	updateActiveThumbnail: function (index) {
		// Only apply on mobile
		if (window.innerWidth > 798) return;

		let thumbnails = document.querySelectorAll(
			".pdp-flickity-thumbnails .product-gallery__thumbnail"
		);
		thumbnails.forEach(function (thumb, i) {
			if (i === index) {
				thumb.classList.add("is-active");
			} else {
				thumb.classList.remove("is-active");
			}
		});
	},

	// Center thumbnail carousel on active thumbnail
	centerThumbnailOnActive: function (index) {
		// Only apply on mobile and if thumbnail carousel exists
		if (window.innerWidth > 798 || !this.thumbnailFlickity) return;

		// Get thumbnail cells
		let thumbnailCells = this.thumbnailFlickity.getCellElements();

		if (index >= thumbnailCells.length) return;

		// Get the target cell and container dimensions
		let targetCell = thumbnailCells[index];
		let container = this.thumbnailFlickity.element;

		if (!targetCell || !container) return;

		// Get cell position relative to slider
		let cellRect = targetCell.getBoundingClientRect();
		let containerRect = container.getBoundingClientRect();

		// Calculate how much to scroll to center the cell
		let cellCenter = cellRect.left + cellRect.width / 2;
		let containerCenter = containerRect.left + containerRect.width / 2;
		let scrollOffset = cellCenter - containerCenter;

		// Get current scroll position and calculate new position
		let currentX = this.thumbnailFlickity.x || 0;
		let newX = currentX - scrollOffset;

		// Use Flickity's internal method to scroll to position
		if (Math.abs(scrollOffset) > 10) {
			// Only scroll if offset is significant
			this.thumbnailFlickity.x = newX;
			this.thumbnailFlickity.settle(this.thumbnailFlickity.x);
		}
	},

	// Update image counter display
	updateImageCounter: function () {
		// Only show counter on mobile
		if (window.innerWidth > 798) return;

		let counter = document.getElementById("pdp-image-counter");
		let mobileCounter = document.getElementById("mobile-image-counter");

		if (this.mobileFlickity) {
			let currentSlide = this.mobileFlickity.selectedIndex + 1;
			let totalSlides = this.mobileFlickity.slides.length;
			let counterText = currentSlide + "/" + totalSlides;

			if (counter) {
				counter.textContent = counterText;
			}
			if (mobileCounter) {
				mobileCounter.textContent = counterText;
			}
		}
	},

	// Update scrollbar position
	updateScrollbar: function () {
		// Only show scrollbar on mobile
		if (window.innerWidth > 798 || !this.mobileFlickity) return;

		let scrollbar = document.getElementById("pdp-scrollbar");
		if (!scrollbar) return;

		// Create or get the scrollbar drag element
		let scrollbarDrag = scrollbar.querySelector(".swiper-scrollbar-drag");
		if (!scrollbarDrag) {
			scrollbarDrag = document.createElement("div");
			scrollbarDrag.className = "swiper-scrollbar-drag";
			scrollbar.appendChild(scrollbarDrag);
		}

		let currentSlide = this.mobileFlickity.selectedIndex;
		let totalSlides = this.mobileFlickity.slides.length;
		let scrollbarWidth = scrollbar.offsetWidth;

		// Calculate drag element width and position
		let dragWidth = Math.max(20, scrollbarWidth / totalSlides); // Min 20px width
		let dragPosition =
			(currentSlide / (totalSlides - 1)) * (scrollbarWidth - dragWidth);

		// Apply styles
		scrollbarDrag.style.width = dragWidth + "px";
		scrollbarDrag.style.left = dragPosition + "px";
	},

	// Initialize scrollbar drag functionality
	initScrollbarDrag: function () {
		// Only enable scrollbar on mobile
		if (window.innerWidth > 798) return;

		let scrollbar = document.getElementById("pdp-scrollbar");
		if (!scrollbar || !this.mobileFlickity) return;

		let self = this;
		let isDragging = false;

		// Handle click on scrollbar track
		scrollbar.addEventListener("click", function (e) {
			if (e.target === scrollbar) {
				let rect = scrollbar.getBoundingClientRect();
				let clickX = e.clientX - rect.left;
				let percentage = clickX / rect.width;
				let targetSlide = Math.round(
					percentage * (self.mobileFlickity.slides.length - 1)
				);

				self.mobileFlickity.select(targetSlide);
			}
		});

		// Handle drag on scrollbar drag element
		let scrollbarDrag = scrollbar.querySelector(".swiper-scrollbar-drag");
		if (scrollbarDrag) {
			scrollbarDrag.addEventListener("mousedown", function (e) {
				isDragging = true;
				e.preventDefault();
			});

			document.addEventListener("mousemove", function (e) {
				if (!isDragging) return;

				let rect = scrollbar.getBoundingClientRect();
				let dragX = e.clientX - rect.left;
				let percentage = Math.max(0, Math.min(1, dragX / rect.width));
				let targetSlide = Math.round(
					percentage * (self.mobileFlickity.slides.length - 1)
				);

				self.mobileFlickity.select(targetSlide);
			});

			document.addEventListener("mouseup", function () {
				isDragging = false;
			});
		}
	},

	// Set up variant and other event listeners
	setupEventListeners: function () {
		// Event listeners are now set up in product__images.liquid
		// to properly integrate with the existing selectCallback system
	},

	// Set up navigation button event listeners
	setupNavigationButtons: function () {
		let self = this;

		// Previous button
		let prevButton = document.querySelector(".pdp-slider-prev");
		if (prevButton) {
			prevButton.addEventListener("click", function () {
				if (self.mobileFlickity) {
					self.mobileFlickity.previous();
				}
			});
		}

		// Next button
		let nextButton = document.querySelector(".pdp-slider-next");
		if (nextButton) {
			nextButton.addEventListener("click", function () {
				if (self.mobileFlickity) {
					self.mobileFlickity.next();
				}
			});
		}
	},

	// Handle variant change
	handleVariantChange: function (detail) {
		if (!detail) return;

		// First, ensure all slides are visible
		this.showAllSlides();

		// Extract color from variant detail
		let color =
			detail.thumbnailColor ||
			(detail.variant && detail.variant.option1) ||
			null;

		// Get variant image ID from event detail
		let imageId =
			detail.imageId || detail.featured_image_id || detail.image_id;

		// Navigate to appropriate image
		setTimeout(() => {
			if (imageId) {
				// Navigate to the specific image
				this.navigateToImage(imageId);
			} else if (color) {
				// If no specific image ID, navigate to first image of this color
				this.navigateToFirstColorImage(color);
			}
		}, 100);
	},

	// Handle variant selection from dropdown
	handleVariantSelection: function (variantId) {
		let selector = document.querySelector("[data-variant-selector]");
		if (!selector) return;

		let selectedOption = selector.querySelector(
			'option[value="' + variantId + '"]'
		);
		if (!selectedOption) return;

		let imageId = selectedOption.getAttribute("data-image-id");
		let thumbnailColor = selectedOption.getAttribute("data-thumbnail-color");

		if (imageId) {
			this.navigateToImage(imageId);
		}

		if (thumbnailColor) {
			this.filterByColor(thumbnailColor);
		}
	},

	// Navigate to specific image by ID
	navigateToImage: function (imageId) {
		if (!this.mobileFlickity) {
			return;
		}

		if (!imageId) {
			return;
		}

		// Find slide with matching image ID
		let cells = this.mobileFlickity.getCellElements();

		for (let i = 0; i < cells.length; i++) {
			let cell = cells[i];

			// Look for image with matching data-image-id attribute
			let matchingImg = cell.querySelector(
				'img[data-image-id="' + imageId + '"]'
			);

			// Also check if image ID matches the img element's id
			if (!matchingImg) {
				matchingImg = cell.querySelector('img[id="' + imageId + '"]');
			}

			if (matchingImg) {
				this.mobileFlickity.select(i);

				// Update mobile-only UI elements
				if (window.innerWidth <= 798) {
					// Update counter immediately
					this.updateImageCounter();

					// Also update thumbnail active state
					this.updateActiveThumbnail(i);
					// Removed centerThumbnailOnActive - let Flickity handle positioning
					this.updateScrollbar();
				}
				return;
			}
		}
	},

	// Navigate to first image of specified color
	navigateToFirstColorImage: function (color) {
		if (!this.mobileFlickity || !color) {
			return;
		}

		let cells = this.mobileFlickity.getCellElements();
		let targetColor =
			"#color_" +
			color.toLowerCase().replace(/\s+/g, "_").replace(/-/g, "_");

		for (let i = 0; i < cells.length; i++) {
			let cell = cells[i];
			let thumbnailColor = cell.getAttribute("thumbnail-color");

			if (thumbnailColor) {
				let cleanColor = thumbnailColor.replace(/-/g, "_").toLowerCase();

				if (cleanColor === targetColor) {
					// Navigate to the matching slide
					this.mobileFlickity.select(i);

					// Update mobile-only UI elements
					if (window.innerWidth <= 798) {
						// Update counter immediately
						this.updateImageCounter();

						// Update thumbnail to match
						if (this.thumbnailFlickity) {
							// Use select with instant option to prevent animation issues
							this.thumbnailFlickity.select(i, false, true); // index, isWrapped, isInstant
							// Also update thumbnail active state
							this.updateActiveThumbnail(i);
							// Removed centerThumbnailOnActive - let Flickity handle positioning
						}

						// Update scrollbar
						this.updateScrollbar();
					}
					return;
				}
			}
		}
	},

	// Filter media by variant color
	filterMediaByColor: function (variant) {
		// Try to get color from variant options
		let color = null;

		if (variant.options && variant.options.length > 0) {
			// Usually color is the first option
			color = variant.options[0];
		} else if (variant.option1) {
			color = variant.option1;
		}

		if (color) {
			this.filterByColor(color);
		}
	},

	// Filter slides by color
	filterByColor: function (color) {
		if (!this.mobileFlickity || !color) {
			return;
		}

		let cells = this.mobileFlickity.getCellElements();
		let targetColor =
			"#color_" +
			color.toLowerCase().replace(/\s+/g, "_").replace(/-/g, "_");

		let firstVisibleIndex = -1;

		cells.forEach(function (cell, index) {
			let thumbnailColor = cell.getAttribute("thumbnail-color");
			if (thumbnailColor) {
				let cleanColor = thumbnailColor.toLowerCase().replace(/-/g, "_");

				// Show slide if it matches the color or has no color designation
				if (cleanColor === targetColor || !cleanColor.includes("#color")) {
					cell.style.display = "";
					if (firstVisibleIndex === -1) {
						firstVisibleIndex = index;
					}
				} else {
					cell.style.display = "none";
				}
			}
		});

		// Update Flickity after filtering
		this.mobileFlickity.resize();

		// Navigate to first visible slide
		if (firstVisibleIndex !== -1) {
			this.mobileFlickity.select(firstVisibleIndex);
		}

		this.updateImageCounter();
	},

	// Pause videos in inactive slides
	pauseInactiveMedia: function () {
		if (!this.mobileFlickity) return;

		let cells = this.mobileFlickity.getCellElements();
		let activeIndex = this.mobileFlickity.selectedIndex;

		cells.forEach(function (cell, index) {
			if (index !== activeIndex) {
				let video = cell.querySelector("video");
				if (video) {
					video.pause();
				}
			}
		});
	},

	// Play video in active slide
	playActiveVideo: function (slide) {
		// Placeholder for video autoplay logic
		// Would integrate with Plyr or native video
		let video = slide.querySelector("video");
		if (video && video.paused) {
			// Check autoplay settings before playing
			// video.play();
		}
	},

	// Show all slides (no filtering)
	showAllSlides: function () {
		let slides = document.querySelectorAll(".pdp-slider .carousel-cell");

		// Force show all slides
		slides.forEach(function (slide, index) {
			slide.style.display = "";
			slide.style.visibility = "";
		});

		// Force update flickity instances
		if (this.mobileFlickity) {
			this.mobileFlickity.resize();
			this.mobileFlickity.reposition();
		}
	},

	// Destroy flickity instances (for cleanup)
	destroy: function () {
		if (this.mobileFlickity) {
			this.mobileFlickity.destroy();
			this.mobileFlickity = null;
		}

		if (this.thumbnailFlickity) {
			this.thumbnailFlickity.destroy();
			this.thumbnailFlickity = null;
		}
	},

	// Update flickity instances after DOM changes
	update: function () {
		if (this.mobileFlickity) {
			this.mobileFlickity.resize();
			this.mobileFlickity.reposition();
		}

		if (this.thumbnailFlickity) {
			this.thumbnailFlickity.resize();
			this.thumbnailFlickity.reposition();
		}
	},
};
